import styled from 'styled-components';

export const PageWrapper = styled.section`
    width: 100%;
    height: 100%;
    background-color: #01606F;
    padding: 100px 0px;

    @media screen and (max-width: 767px){
        padding: 80px 0px;
    }
`;

export const PageGroup = styled.div`
    width: 100%;
    text-align: center;
`;

export const PageContentBox = styled.div`
    max-width: 600px;
    width: 100%;    
    background-color: rgba(78, 180, 219, 0.33);
    color: #fff;
    font-size: 200px;
    font-family: "Jost", serif-serif;
    font-weight: 600;
    line-height: 220px; 
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin: 0 auto 50px;
    padding: 30px 0;
    border-radius: 50px;
    box-shadow: 0 10px 0px 0 rgba(78, 180, 219, 0.6);

    @media screen and (max-width: 991px){
        font-size: 150px;
        line-height: 170px; 
        border-radius: 30px;
    }
    
    @media screen and (max-width: 767px){
        font-size: 120px;
        line-height: 140px; 
    }
    
    @media screen and (max-width: 575px){
        font-size: 100px;
        line-height: 110px; 
        gap: 15px;
        border-radius: 20px;
    }

    @media screen and (max-width: 480px){
        font-size: 90px;
        line-height: 100px;
        gap: 10px;
    }
`;

export const PageText = styled.p`
    padding: 0;
    margin: 0;
`;

export const PageTextImg = styled.div`
    max-width: 150px;

    @media screen and (max-width: 991px){
        max-width: 130px; 
    }
    @media screen and (max-width: 767px){
        max-width: 110px;
    }
    @media screen and (max-width: 480px){
        max-width: 80px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
    }
`;

export const PageTitle = styled.h2`
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 60px;
    font-family: "Jost", serif-serif;
    font-weight: 600;
    line-height: 70px;

    @media screen and (max-width: 991px){
        font-size: 50px;
        line-height: 60px; 
    }

    @media screen and (max-width: 767px){
        font-size: 44px;
        line-height: 54px; 
    }

    @media screen and (max-width: 575px){
        font-size: 40px;
        line-height: 50px; 
    }

    @media screen and (max-width: 480px){
        font-size: 34px;
        line-height: 44px; 
    }
`;

export const PageSubText = styled.p`
    max-width: 700px;
    margin: 20px auto 0;
    text-align: center;
    color: #fff;
    font-size: 20px;
    font-family: "Jost", serif-serif;
    font-weight: 400;
    line-height: 30px; 

    @media screen and (max-width: 767px){
        font-size: 18px;
        line-height: 28px; 
    }

    @media screen and (max-width: 480px){
        font-size: 16px;
        line-height: 26px; 
    }
`;

export const PageBackButton = styled.button`
    width: 100%;
    max-width: 250px;
    margin: 30px auto 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;

    &.write-yellow-btn{
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
        padding: 15px 20px;
        border: none;

        @media screen and (max-width: 575px){
            padding: 12px 15px;
        }
    }

`;

export const BackButtonArrow = styled.a`
    display: block;
    margin-top: -4px;

    svg{
        
    }
`;